import { useEffect, useState } from 'react';
import '../../../../../assets/css/providercustomers.css';
import '../../../../../assets/css/bookings.css';
import '../../../../../assets/css/filter.css';
import '../../../../../assets/css/tables.css';
import { useDictionary } from '../../../../../utilities/hooks/UseDictionary';
import SearchProviderCustomers from './providercustomers_list/searchProviderCustomers';
import useClientWidth from '../../../../../utilities/hooks/useClientWidth';
import ProviderCustomersItem from './ProviderCustomersItem';
import PaginationController from '../../../common/pagination_controller/PaginationController';
import SimpleLoader from '../../../common/SimpleLoader';
import SortOptionsSelector from '../../../common/sort_options/SortOptionsSelector';
import { useHistory } from 'react-router-dom';
import { NavigatorPaths } from '../../../../../assets/dictionaries/NavigatorPaths';
import { getProviderCustomers } from './networking';

const ProviderCustomers = () =>{
    const dictionary = useDictionary();
    const clientWidth = useClientWidth();
	const history = useHistory()
    const [providerCustomers,setProviderCustomers] = useState([]);
    const [searchParam, setSearchParam] = useState('');
    const [pageSize, setPageSize] = useState(
		parseInt(localStorage.getItem('providercustomers_selected_page_size') ?? 10)
	);
	const [selectedOption, setSelectedOption] = useState(localStorage.getItem('providercustomers_selected_sort_type') ? JSON.parse(localStorage.getItem('providercustomers_selected_sort_type')) : {value: 'created_at', direction: 'desc', label: 'Newest'});
	const [currentPage, setCurrentPage] = useState(0);
	const [dataLength, setDataLength] = useState(0);
	const [showLoader, setShowLoader] = useState(true);

    const columnsConfig = {
		[dictionary.providerName]: { fixed: false, visible: true },
		[dictionary.providerEmail]: { fixed: true, visible: true },
		[dictionary.providerPhoneNumber]: { fixed: false, visible: true },
		[dictionary.providerBookings]: { fixed: false, visible: true },
		[dictionary.providerReviews]: { fixed: false, visible: true },
		[dictionary.providerLastActivity]: { fixed: false, visible: true },
		[dictionary.providerCreateDate]: { fixed: false, visible: true }
	};

    const getProviderCustomersAsync = async () => {
		setShowLoader(true);
		try {
			const {data} = await getProviderCustomers(selectedOption,pageSize,currentPage,searchParam)
			setProviderCustomers(data.data);
			setDataLength(data.recordsFiltered || data?.recordsTotal || 0);
			setShowLoader(false);
		} catch (error) {
			setShowLoader(false);
			console.error('Error fetching providerCustomers:', error);
		}
    }

	const onSortOptionValueChanged = (option) => {
		if(option.value !== selectedOption.value){
			setSelectedOption(option);
		}
	};

    useEffect(()=>{
		setShowLoader(true);
        getProviderCustomersAsync();
    },[pageSize, currentPage, searchParam, selectedOption])

    const onSearchValueChanged = (value) => {
		setCurrentPage(0);
		setSearchParam(value);
	};

    const onProviderCustomersClicked = (item) => {
		history.push(`/${NavigatorPaths.admin_provider_customers.path}/${item.id}`);
    }

    const onPagingParameterChanged = (type, newParameter) => {
		if (type === 'page') {
			setCurrentPage(newParameter);
		} else if (type === 'page-size') {
			setPageSize(newParameter);
		}
	};

    return (
        <div
			className="provider-customers-container"
			style={{
				background: 'var(--background-color)',
				paddingTop: '0'
			}}
		>
            {clientWidth >= 1166 ? (
                <div className="booking-header-container provider-customers-header-container">
                    <h2 className="title-main">
                        {dictionary.providerCustomers}
                    </h2>
                    <div className="flex-filler" />
                    <div className='wrappper_sortoptions'>
                        <SearchProviderCustomers onValueChanged={onSearchValueChanged} />
						<SortOptionsSelector
							onValueChanged={onSortOptionValueChanged}
							name={'providercustomers'}
						/>
                    </div>
                </div>
            ) : null}
            {clientWidth < 1166 ? (
                <div className="booking-header-container provider-customers-mobile-header-container">
                    <div className='mobile-provider-customers-container'>
                        <h2 className="title-main">
                            {dictionary.providerCustomers}
                        </h2>
                    </div>
                    <div className='mobile-provider-customers-container-searchbox d-flex'>
                        <SearchProviderCustomers onValueChanged={onSearchValueChanged} />
						<SortOptionsSelector
							onValueChanged={onSortOptionValueChanged}
							name={'providercustomers'}
						/>
                    </div>
                </div>
            ) : null}
            <div className="upiria-table-container booking-table-container">
				<div className="upiria-table-header-strip" />
				<div className="upiria-table-container-inner thin-scrollbar">
					<table
						cellSpacing="0"
						cellPadding="0"
						border="0"
						className="upiria-table-container-provider-customers-table upiria-table-container-provider-admin-customers-table"
					>
						<thead>
						<tr>
                            {
                                Object.keys(columnsConfig).map(
                                    (col) => columnsConfig[col].visible && <th key={col}>{col}</th>
                                )
                            }
						</tr>
						</thead>
						<tbody>
                            {providerCustomers?.map((item) => (
                                <ProviderCustomersItem
                                    key={item.id}
                                    onProviderCustomersClicked={onProviderCustomersClicked}
                                    item={item}
                                />
                            ))}
						</tbody>
					</table>
				</div>

				{providerCustomers?.length === 0 ? (
					<div
						className="empty-provider-customers-list-wrapper d-flex-center"
						style={{ height: '80%' }}
					>
						<div className="empty-provider-customers-list-placeholder d-flex-center">
							<div className="empty-provider-customers-image" />
							<h3
								data-testid="no-bookings-yet-header"
                                className='empty-provider-customers-title'
							>
								{dictionary.empty_provider_customer_message}
							</h3>
							<div className="text empty-provider-customers-message">
								{dictionary.empty_provider_customer_descriptions}
							</div>
						</div>
					</div>
				) : null}
			</div>
            <PaginationController
				name="providercustomers"
				onParameterChanged={onPagingParameterChanged}
				dataLength={dataLength}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
			/>
			{showLoader ? <SimpleLoader showLoader={showLoader} /> : null}
        </div>
    )
}

export default ProviderCustomers;